import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import {
  DESKTOP_REQUIRED_DESTINATION_QUERY_PARAM,
  DesktopRequiredDestinations,
} from '../desktop-required/desktop-required-destination';
import { BreakpointService } from '../services/breakpoint.service';
import { TripAccessService } from '../services/trip-access/trip-access.service';
import { TripService } from '../services/trip.service';

/**
 * Trip finances: desktop-width only, then finance role (`trip.finance`) only.
 * Delegated leads without finance are sent to dashboard.
 */
export const tripFinancesGuard: CanActivateFn = () => {
  const breakpointService = inject(BreakpointService);
  const router = inject(Router);
  const tripService = inject(TripService);
  const tripAccess = inject(TripAccessService);

  if (breakpointService.isMobile()) {
    return router.createUrlTree(['/desktop-required'], {
      queryParams: {
        [DESKTOP_REQUIRED_DESTINATION_QUERY_PARAM]:
          DesktopRequiredDestinations.TripFinances,
      },
    });
  }

  if (!tripService.currentTripLoaded()) {
    return true;
  }

  const trip = tripService.currentTrip.value();
  if (!tripAccess.context(trip)?.isFinance) {
    return router.createUrlTree(['/dashboard']);
  }

  return true;
};
